export const heatpumpSgReadySocSettings =
  "Batterieladezustand für SG-Ready einschränken";

export const sgReadyHelp =
  "Ihre Wärmepumpe ist SG-Ready-fähig. Dies bedeutet, dass die Soll-Temperatur erhöht werden kann, wenn viel " +
  "Sonnenenergie verfügbar ist. Zur Schonung Ihrer Wärmepumpe sollte dies jedoch nicht beliebig oft erfolgen. Die " +
  "Steuerung der Wärmepumpe übernimmt das System für Sie basierend auf Wetter- und Lastvorhersagen. Daher sehen Sie " +
  "hier lediglich den Status, können Ihn aber nicht manuell ändern. Bitte beachten Sie, dass es ein paar Tage dauern " +
  "kann, bis die Soll-Temperatur der Wärmepumpe das erste Mal bei hoher PV-Erzeugung erhöht wird, da zunächst ein " +
  "Kalibiervorgang für die Schätzung der Verbrauchswerte läuft.";

export const sgReadyTitle = "PV-Einschaltbefehl";
